<template>
  <div class="block">
    <span
      v-for="(item, index) in blockName"
      :class="['name', {'active': item.isActive}]"
      :title="item.name"
      :key="index"
      @click="changeStrategy(index)">{{ item.name }}</span>
  </div>
</template>

<script>
export default {
  props: {
    blockName: Array
  },
  methods: {
    changeStrategy (index) {
      this.$emit('changeS', index)
    }
  }
}
</script>

<style lang="scss">
@import '../../../common/scss/color.scss';

.block {
  width: 1300px;
  margin-top: 24px;
  border-top: 1px solid $borderColor;
  height: 0;
  .name {
    max-width: 160px;
    cursor: pointer;
    font-size: 16px;
    margin-right: 12px;
    display: inline-block;
    color: #666;
    position: relative;
    padding-bottom: 2px;
    padding: 0 6px 2px;
    top: -24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
      color: $mainColor;
    }
    &.active {
      color: $mainColor;
      border-bottom: 1px solid $mainColor;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/public/edit-plan-sub/block.vue